import React from "react";

const LockScreen = () => {
  return <div>LockScreen</div>;
};

export default LockScreen;